<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.UnicodeCodec.title') }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" icon="el-icon-sort" type="primary" @click="encode">{{ $t('common.action.encode') }}</el-button>
      <el-button size="small" @click="decode">{{ $t('common.action.decode') }}</el-button>
      <el-button size="small" plain icon="el-icon-star-off" @click="loadSample">{{ $t('common.action.sample') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t('common.action.copy') }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t('common.action.clear') }}</el-button>
    </div>
    <el-input v-model="text" type="textarea" :rows="14"
      :placeholder="focused ? $t('tool.UnicodeCodec.phPasted') : $t('tool.UnicodeCodec.phInput')"
      class="fmt-textarea" @input="onInput" @focus="focused=true" @blur="focused=false"/>
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning"/> {{ errorMsg }}</span>
      <span v-else-if="lastOp" class="fmt-ok"><i class="el-icon-circle-check"/> {{ lastOp }}</span>
      <span v-else-if="text.trim()" class="fmt-hint">{{ detectHint || $t('common.hint.charCount', { n: charCount }) }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.UnicodeCodec.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'UnicodeCodecTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return { text:'', errorMsg:'', lastOp:'', detectHint:'', focused:false }
  },
  computed:{
    charCount:function(){ return this.text.length }
  },
  methods:{
    onInput:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (this.text.trim()) {
        var hasUnicode = /\\u[0-9a-fA-F]{4}/.test(this.text) || /&#x?[0-9a-fA-F]+;/.test(this.text) || /U\+[0-9a-fA-F]{4,6}/i.test(this.text) || /%[0-9a-fA-F]{2}/.test(this.text)
        this.detectHint = hasUnicode ? this.$t('tool.UnicodeCodec.detectEncoded') : this.$t('tool.UnicodeCodec.detectPlain')
      }
    },
    encode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        var result = ''
        for (var i = 0; i < this.text.length; i++) {
          var code = this.text.charCodeAt(i)
          if (code > 0x7f || code < 0x20) {
            result += '\\u' + ('000' + code.toString(16)).slice(-4)
          } else {
            result += this.text.charAt(i)
          }
        }
        this.text = result
        this.lastOp = this.$t('tool.UnicodeCodec.msgEncoded', { n: this.text.length })
      } catch(e) { this.errorMsg = this.$t('tool.UnicodeCodec.msgEncodeFail', { msg: e.message }) }
    },
    decode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        var s = this.text
        // 处理各种 Unicode 转义格式
        // 1. &#xXXXX; / &#DDDD; HTML 实体
        s = s.replace(/&#x([0-9a-fA-F]+);/g, function(m, hex) {
          return String.fromCharCode(parseInt(hex, 16))
        })
        s = s.replace(/&#(\d+);/g, function(m, dec) {
          return String.fromCharCode(parseInt(dec, 10))
        })
        // 2. U+XXXX 或 U+XXXXXX 格式
        s = s.replace(/U\+([0-9a-fA-F]{4,6})/g, function(m, hex) {
          return String.fromCharCode(parseInt(hex, 16))
        })
        // 3. \uXXXX 格式（含代理对 \uD800-\uDFFF）
        s = s.replace(/\\u([0-9a-fA-F]{4})/g, function(m, hex) {
          return String.fromCharCode(parseInt(hex, 16))
        })
        // 4. %XX 百分号编码（URL 编码）
        s = s.replace(/%([0-9a-fA-F]{2})/g, function(m, hex) {
          return String.fromCharCode(parseInt(hex, 16))
        })
        this.text = s
        this.lastOp = this.$t('tool.UnicodeCodec.msgDecoded', { n: this.text.length })
      } catch(e) {
        this.errorMsg = this.$t('tool.UnicodeCodec.msgDecodeFail')
      }
    },
    loadSample:function(){ this.text = this.$t('tool.UnicodeCodec.sample'); this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    doCopy:function(){
      if (!this.text.trim()) { this.$message.warning(this.$t('common.status.noContent')); return }
      navigator.clipboard.writeText(this.text).then(this.$message.success(this.$t('common.status.copied')))
    },
    clearAll:function(){ this.text = ''; this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    doAction:function(a){
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 280px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
